import { Box, SxProps, styled } from '@mui/material';
import { ForwardedRef, forwardRef, memo, PropsWithChildren, ReactElement } from 'react';

export interface ChipWrapperProps extends PropsWithChildren {
  sx?: SxProps;
}

/**
 * ChipWrapperLayout is a styled component wrapping children in a Card with default styles.
 * You can override the default styles by passing a `sx` prop.
 *
 * Supports `forwardRef` to allow parent components to access the underlying DOM element.
 * This enables features like focus management (Tooltips) or animations.
 */
export const ChipWrapperLayout = memo(
  forwardRef(function (props: ChipWrapperProps, ref: ForwardedRef<HTMLDivElement>): ReactElement {
    const { children, sx, ...rest } = props;

    return (
      <StyledCard {...rest} ref={ref} sx={{ ...sx }}>
        {children}
      </StyledCard>
    );
  })
);

const StyledCard = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  alignItems: 'stretch',
  borderRadius: '10px',
  border: '1px solid rgba(0, 0, 0, 0.12)',
  width: '100%',
});
